import { render, staticRenderFns } from "./TradeNameConfigs.vue?vue&type=template&id=6aef7bfa"
import script from "./TradeNameConfigs.vue?vue&type=script&lang=js"
export * from "./TradeNameConfigs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aef7bfa')) {
      api.createRecord('6aef7bfa', component.options)
    } else {
      api.reload('6aef7bfa', component.options)
    }
    module.hot.accept("./TradeNameConfigs.vue?vue&type=template&id=6aef7bfa", function () {
      api.rerender('6aef7bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/invoices/components/TradeNameConfigs.vue"
export default component.exports